import { Post } from 'redux/reducers/feed'

import React from 'react'
import { IComment, RootState } from 'constants/interfaces'
import { useDispatch, useSelector } from 'react-redux'
import useComments from 'hooks/useComments'
import { getCommentActivity } from 'redux/actions/comments'
import { BaseModalV2 } from 'components/ui/BaseModal'
import { AnnouncementCommentModalHeader } from './AnnouncementCommentModalHeader'
import { AnnouncementCommentModalBody } from './AnnouncementCommentModalBody'
import { AnnouncementCommentModalFooter } from './AnnouncementCommentModalFooter'

export const AnnouncementCommentModal = ({
  chat,
  message,
  onBack,
  onClose,
  targetCommentId,
}: {
  chat: Post
  message: IComment
  onBack: () => void
  onClose: () => void
  targetCommentId?: string | null
}) => {
  const dispatch = useDispatch()
  const { uid } = useSelector((state: RootState) => state.auth)
  const { isFetching } = useSelector((state: RootState) => state.comments)

  const {
    fetchComments: fetchReplies,
    fetchCommentsLoading: fetchRepliesLoading,
    commentsCounter: repliesCounter,
    commentsCounterLoading: repliesCounterLoading,
    sendComment: sendReply,
    sendCommentLoading: sendReplyLoading,
    fetchCommentsCounter,
  } = useComments(message.cid, true)

  const replies = useSelector((state: RootState) => state.comments.repliesState?.[message.cid] ?? undefined)
  const { commentContext } = useSelector((state: RootState) => state.feed)
  const { likes, views } = useSelector((state: RootState) => state.comments.commentsActivity?.[message.cid] ?? {})

  // Загружаем активность комментария (лайки, просмотры) и счетчик ответов
  React.useEffect(() => {
    if (!isFetching && !message.isDummy) {
      dispatch(getCommentActivity(message.cid))
      fetchCommentsCounter(message.cid, chat.post_id)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [message.cid, chat.post_id])

  return (
    <BaseModalV2
      isOpen={true}
      onClose={onClose}
      header={<AnnouncementCommentModalHeader chat={chat} message={message} onBack={onBack} />}
      modalBodyProps={{ overflow: 'hidden', py: 0, px: 0, height: '70vh' }}
      body={
        <AnnouncementCommentModalBody
          chatId={chat.post_id}
          parentCID={message.cid}
          fetchReplies={fetchReplies}
          fetchRepliesLoading={fetchRepliesLoading}
          replies={replies}
          repliesCounter={repliesCounter}
          message={message}
          chat={chat}
          likes={likes}
          views={views}
          repliesCounterLoading={repliesCounterLoading}
          targetCommentId={targetCommentId}
        />
      }
      footer={
        <AnnouncementCommentModalFooter
          chat={chat}
          message={message}
          replies={replies?.items ?? []}
          commentContext={commentContext}
          sendReply={sendReply}
          sendReplyLoading={sendReplyLoading}
          repliesCounter={repliesCounter}
          uid={uid}
        />
      }
    />
  )
}
